import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 5CE920A6-F65C-4EB4-8015-455032417296
 * name invoice
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invoice.svg
 * tags
 * - Banking 
 */
export const InvoiceIcon = createSvgIcon(<><path d="M21 22L18 20L15 22L12 20L9 22L6 20L3 22V3H21V22Z" /></>, 'InvoiceIcon');
export default InvoiceIcon